import { useTranslation } from 'react-i18next';
import styles from '../styles/components/Hero.module.css';

function Hero() {
  const { t } = useTranslation();

  return (
    <section className={styles.hero}>
      <h1 className={styles.title}>{t('hero.title')}</h1>
      <p className={styles.subtitle}>{t('hero.subtitle')}</p>
    </section>
  );
}

export default Hero;
